var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { action, autorun, flow, reaction, runInAction } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useControllers } from '../../hooks/controller.hooks';
import { useOnMount } from '../../hooks/lifecycle.hooks';
import { pushToOrReplaceItemsInArray } from '../../utils/array.utils';
import joinClassName from '../../utils/className.utils';
import { reportError } from '../../utils/errors.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { YYYYMMDD } from '../../utils/time.utils';
import tick from '../../utils/waiters.utils';
import LoadingBlocker from '../LoadingBlocker/LoadingBlocker';
import './BaseCalendar.scss';
import BaseCalendarBody from './BaseCalendarBody';
import BaseCalendarHeader from './BaseCalendarHeader';
import BaseCalendarWeekHeader from './BaseCalendarWeekHeader';
var BaseCalendar = function (props) {
    var _a = useControllers(), STORAGE = _a.STORAGE, UI = _a.UI;
    var p = useProps(props);
    var s = useStore(function () { return ({
        get calendarState() {
            return p.state;
        },
        get storageKey() {
            return __spreadArray(__spreadArray([], [p.storageKey].flat(), true), [s.calendarState.name], false);
        },
        internalCalendarEvents: [],
        get calendarEvents() {
            var events = __spreadArray(__spreadArray([], s.internalCalendarEvents, true), p.events || [], true);
            if (p.eventDataFilter)
                return events.filter(function (e) { return e.data ? p.eventDataFilter(e.data) : true; });
            return events;
        },
        hasReadFromStorage: true,
        dataFetcherState: {
            isLoading: false,
            error: null,
        },
        firstDataLoaded: false,
    }); });
    var onNavigate = function (newStartDate) {
        p.onNavigate && p.onNavigate(newStartDate, s.calendarState);
        runDataFetcher(newStartDate);
    };
    var runDataFetcher = flow(function (startTime) {
        var endTime, newEvents, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    // console.log('[BaseCalendar] runDataFetcher called', p.dataFetcher);
                    if (!p.dataFetcher)
                        return [2 /*return*/];
                    endTime = s.calendarState.endDateMoment.add(1, 'day').format(YYYYMMDD);
                    s.dataFetcherState.isLoading = true;
                    return [4 /*yield*/, p.dataFetcher(startTime || s.calendarState.startDate, endTime)];
                case 1:
                    newEvents = _b.sent();
                    pushToOrReplaceItemsInArray(s.internalCalendarEvents, newEvents, function (e, arr) {
                        // @ts-ignore
                        var id = (e || {}).id;
                        if (!id)
                            return -1;
                        return arr.findIndex(function (a) { return a.id && (a.id + '' === id + ''); });
                    });
                    if (!s.firstDataLoaded) {
                        (_a = p.onFirstDataLoad) === null || _a === void 0 ? void 0 : _a.call(p, newEvents.map(function (e) { return e.data; }));
                        s.firstDataLoaded = true;
                    }
                    return [3 /*break*/, 4];
                case 2:
                    e_1 = _b.sent();
                    s.dataFetcherState.error = e_1;
                    reportError(e_1);
                    return [3 /*break*/, 4];
                case 3:
                    s.dataFetcherState.isLoading = false;
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
    function readCalendarStateFromStorage() {
        STORAGE.get(s.storageKey).then(action(function (snapshot) {
            var _a;
            if (snapshot) {
                try {
                    // @ts-ignore
                    Object.entries(snapshot).forEach(function (entry) { return (entry[0] in s.calendarState) && (s.calendarState[entry[0]] = entry[1]); });
                    (_a = snapshot.inactiveEventTypesByGroup) === null || _a === void 0 ? void 0 : _a.forEach(function (group) {
                        var eventTypeGroup = s.calendarState.eventTypeGroups.find(function (g) { return g.name === group.name; });
                        eventTypeGroup === null || eventTypeGroup === void 0 ? void 0 : eventTypeGroup.eventTypes.forEach(function (et) { return et.isActive = !group.inactiveEventTypeNames.includes(et.name); });
                    });
                }
                catch (e) {
                    reportError(e);
                }
                finally {
                    s.hasReadFromStorage = true;
                }
            }
            runDataFetcher();
        }));
    }
    var persistToStorage = function () {
        var _a = s.calendarState, name = _a.name, mode = _a.mode, fullHeight = _a.fullHeight, fitInnerToAvailableHeight = _a.fitInnerToAvailableHeight, showEventEndTimes = _a.showEventEndTimes, eventTypeGroups = _a.eventTypeGroups;
        var inactiveEventTypesByGroup = eventTypeGroups.map(function (g) { return ({
            name: g.name,
            inactiveEventTypeNames: g.eventTypes.filter(function (et) { return !et.isActive; }).map(function (et) { return et.name; })
        }); });
        var snapshot = { name: name, mode: mode, fullHeight: fullHeight, fitInnerToAvailableHeight: fitInnerToAvailableHeight, showEventEndTimes: showEventEndTimes, inactiveEventTypesByGroup: inactiveEventTypesByGroup };
        STORAGE.set(s.storageKey, snapshot);
    };
    useOnMount(function () {
        var disposers = [];
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, tick(100)];
                    case 1:
                        _a.sent();
                        if (!p.shouldPersistState) {
                            runInAction(function () { return s.hasReadFromStorage = true; });
                            runDataFetcher();
                        }
                        else {
                            readCalendarStateFromStorage();
                            disposers.push(autorun(persistToStorage));
                        }
                        disposers.push(reaction(function () { return s.calendarState.mode; }, function () {
                            runDataFetcher();
                        }));
                        disposers.push(reaction(function () { return p.dataFetcher + "_" + p.dataFetcherTriggerString; }, function () {
                            s.internalCalendarEvents.splice(0);
                            runDataFetcher();
                        }));
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () { return disposers.forEach(function (fn) { return fn(); }); };
    });
    return React.createElement(Observer, { children: function () { return (React.createElement("section", { className: joinClassName('BaseCalendar', p.className, s.calendarState.fullHeight && 'fullHeight', s.calendarState.fitInnerToAvailableHeight && 'fitInnerToAvailableHeight'), "data-view-mode": s.calendarState.mode, "data-loading": s.dataFetcherState.isLoading },
            React.createElement("div", { className: "BaseCalendarInner" },
                p.showHeader && React.createElement(BaseCalendarHeader, __assign({}, props, { internalCalendarEvents: s.calendarEvents, onNavigate: onNavigate })),
                p.showHeader || React.createElement(BaseCalendarWeekHeader, { format: "singleChar" }),
                React.createElement(BaseCalendarBody, __assign({}, props, { internalCalendarEvents: s.calendarEvents }))),
            s.dataFetcherState.isLoading && React.createElement(LoadingBlocker, null))); } });
};
export default React.memo(BaseCalendar);
